module.exports = function (fox, v) {
	var alias = 'regexp';
	var Validator_Regexp = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Regexp, fox.mixin({
		_predefined: {
			emailCaseInsensitive: fox.regexp.email,
			email: /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
			decimal: fox.regexp.decimal,
			int: fox.regexp.int,
			onlyEnLet:/^[a-zA-Z][a-zA-Z0-9-_\.]{1,20}$/,
			onlyLatinText: /^[\w\s\.\-,\(\)\/\\]+$/i,
			hostname: fox.regexp.hostname,
			ip: fox.regexp.ip
		},
		_regexp: null,

		_init: function() {
			if (this._options.type && this._predefined[this._options.type]) {
				this._regexp = this._predefined[this._options.type];
			} else if (this._options.regexp) {
				if (fox.isString(this._options.regexp)) {
					this._regexp = new RegExp(this._options.regexp);
				} else {
					this._regexp = this._options.regexp;
				}
			}
		},

		validate: function() {
			if (this._regexp === null) {
				this._init();
			}

			if (!this._regexp) {
				return true;
			}

			return this._regexp.test(this._value);
		}
	}, v._.getBaseHelper()), null, 'Validator_Regexp'));
};



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/validator/validators/regexp.js
// module id = 237
// module chunks = 0